import { css, SerializedStyles } from '@emotion/core'
import React from 'react'

interface ProgressBarProps {
  className?: string
  height?: string
  fillColor?: string
  infiniteLoop?: boolean
  isCurrent: boolean
  tabDuration: number
  cssStyles?: SerializedStyles
}

const ProgressBar: React.FunctionComponent<ProgressBarProps> = ({
  className,
  height = '4px',
  fillColor = 'linear-gradient(135deg, #54d5eb, #266eea)',
  infiniteLoop = false,
  isCurrent,
  tabDuration,
  cssStyles = '',
}) => {
  return (
    <div className={className} css={[progressBarStyle(height), cssStyles]}>
      <div css={filler(isCurrent, fillColor, infiniteLoop, tabDuration)} />
    </div>
  )
}

export default ProgressBar

const progressBarStyle = (height: string) => css`
  height: ${height};
  background: #f7f7f8;
  border-radius: 0.25rem;
  overflow: hidden;
  margin-top: 0.75rem;
`

const filler = (isCurrent: boolean, fillColor: string, infiniteLoop: boolean, tabDuration?: number) => css`
  height: 100%;
  width: 100%;
  background: ${isCurrent ? fillColor : '#f7f7f8;'};

  ${isCurrent && `animation: progress ${tabDuration}s linear ${infiniteLoop ? 'infinite' : ''}`};

  @keyframes progress {
    0% {
      width: 0%;
    }
    100% {
      width: 100%;
    }
  }
`
